'use client';

import TradingPlatformDesktop from './trading-platform-desktop';
import TradingPlatformMobile from './trading-platform-mobile';

export default function TradingPlatformSection() {


  // Render appropriate component based on screen size
  // Using CSS classes for initial render, then dynamic import handles the rest
  return (
    <>
      {/* Desktop - hidden on mobile */}
      <div className="hidden lg:block">
        <TradingPlatformDesktop />
      </div>
      
      {/* Mobile - hidden on desktop */}
      <div className="lg:hidden">
        <TradingPlatformMobile />
      </div>
    </>
  );
}

